import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig, profile } from 'config/config'; // Importing configuration settings and user profile

/**
 * Class representing a view for the agent list table.
 * @extends JetView
 */
export default class tableAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        var bankname; // Variable to store bank name
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format utility
        const vthis = this; // Reference to the current context

        /**
         * Custom checkbox template function.
         * @param {Object} obj - The data object for the row.
         * @param {Object} common - Common template functions.
         * @param {string} value - The value to determine checkbox display.
         * @returns {string} - HTML string for the custom checkbox.
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'N') return ''; // Return empty if value is not 'N'
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton \'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton blocked\'> N </div>'; // Return custom checkbox HTML
        }

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'treetable', // Treetable view for displaying hierarchical data
                            id: 'treetable', // ID for the treetable
                            select: true, // Enable row selection
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'Partner', // Column ID for Partner
                                    header: _('Partner'), // Column header with localization
                                    width: 180, // Column width
                                    sort: 'int', // Sorting type
                                    template: function(obj) {
                                        if (obj.$level == 1) {
                                            return '<span class=\'partner ' + obj.Partner + '\'></span>'; // Display partner name if level is 1
                                        } else {
                                            return ''; // Return empty for other levels
                                        }
                                    },
                                },
                                {
                                    id: 'Country', // Column ID for Country
                                    header: _('País'), // Column header with localization
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    template: function(obj, common) {
                                        if (obj.$level == 1) {
                                            return common.treetable(obj, common); // Return common treetable template for level 1
                                        } else {
                                            return common.treetable(obj, common) + obj.Country; // Append country name for other levels
                                        }
                                    },
                                },
                                {
                                    id: 'detailTittle', // Column ID for detail title
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip with localization
                                    template: function(obj) {
                                        if (obj.$level !== 1 && obj.$level !== 2) {
                                            return '<span class=\'webix_icon wxi-close details\'></span>'; // Show details icon for specific levels
                                        } else {
                                            return ''; // Return empty for other levels
                                        }
                                    },
                                },
                                {
                                    id: 'UserId', // Column ID for User ID
                                    header: _('ID Usuario'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column ID for User Name
                                    header: 'UserName', // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Action', // Column ID for Action
                                    header: 'Transf.', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Acción', // Tooltip for action
                                    template: function(obj) {
                                        if (obj.Id != undefined) {
                                            if (devConfig.getPermAction('agentsTreePay', 'Pay')) {
                                                return '<span placeholder=\'Pagar\' class=\'webix_icon wxi-close icon-tranfer prm-agentsTreePay\'></span>'; // Show transfer icon if permission exists
                                            } else {
                                                return ''; // Return empty if no permission
                                            }
                                        } else {
                                            return ''; // Return empty if no ID
                                        }
                                    },
                                },
                                {
                                    id: 'Currency', // Column ID for Currency
                                    header: _('Moneda'), // Column header with localization
                                    width: 70, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AgentBalance', // Column ID for Agent Balance
                                    header: _('Saldo'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Format for displaying price
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    template: function(obj) {
                                        console.log(obj); // Log object for debugging
                                        if (obj.$level !== 1 && obj.$level !== 2) {
                                            return webix.i18n.priceFormat(obj.AgentBalance); // Format balance for display
                                        } else {
                                            return ''; // Return empty for other levels
                                        }
                                    },
                                },
                                {
                                    id: 'SumAgentBalance', // Column ID for Sum Agent Balance
                                    header: _('Consolidado nivel'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Format for displaying price
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    template: function(obj) {
                                        if (obj.$level !== 1) {
                                            return webix.i18n.priceFormat(obj.SumAgentBalance); // Format sum balance for display
                                        } else {
                                            return ''; // Return empty for level 1
                                        }
                                    },
                                },
                            ],
                            scheme: {
                                $change: function(obj, common) {
                                    if (obj.icon == 'icon-user-secret') {
                                        obj.$css = { background: '#f8f8f8' }; // Change background color for specific icon
                                    }
                                },
                            },
                            type: {
                                folder: function(obj, common) {
                                    if (obj.$level !== 2) {
                                        return '<span class=\'webix_icon ' + obj.icon + '\'></span>'; // Return folder icon for non-level 2
                                    } else {
                                        return '<i class=\'flags ' + obj.flag + '\'></i>'; // Return flag icon for level 2
                                    }
                                },
                            },
                            onClick: {
                                details: function(euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('assignmentQuota:id', [item.Id]); // Call event with item ID
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show(); // Show filter details for small screens
                                    } else {
                                        $$('dColl').expand(); // Expand details for larger screens
                                    }
                                },
                                'icon-tranfer': function(euv, id) {
                                    var vvthis = this; // Reference to current context
                                    var item = vvthis.getItem(id); // Get the clicked item
                                    webix
                                        .ui({
                                            view: 'window', // Create a window for transfer
                                            head: _('Transferir Saldo a ') + item.UserName, // Window header with localization
                                            id: 'windowTransfers', // ID for the transfer window
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                view: 'form', // Form inside the window
                                                id: 'windowTransfersForm', // ID for the form
                                                elements: [
                                                    {
                                                        view: 'text', // Text input for amount
                                                        name: 'amount', // Input name
                                                        label: _('Monto'), // Label with localization
                                                        labelPosition: 'top', // Label position
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        view: 'text', // Text input for transaction ID
                                                        name: 'TransactionId', // Input name
                                                        label: _('Id de transacción relacionada'), // Label with localization
                                                        labelPosition: 'top', // Label position
                                                        required: false, // Not required
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for bank selection
                                                        name: 'BankId', // Input name
                                                        minWidth: 200, // Minimum width
                                                        label: '<span class=\'icon-shop\'></span>' + _('Banco'), // Label with localization
                                                        labelPosition: 'top', // Label position
                                                        placeholder: _('Click para seleccionar '), // Placeholder text
                                                        options: {
                                                            body: {
                                                                dataFeed: function(text) {
                                                                    var vthis = this; // Reference to current context
                                                                    if (text.length > 2) {
                                                                        webix
                                                                            .ajax() // AJAX request to fetch bank data
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                'es/Select/BanksSelect', // API endpoint
                                                                                '{"Filter":"' + text + '"}', // Request body
                                                                                {
                                                                                    error: function(
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        webix.message('Error! '); // Show error message
                                                                                    },
                                                                                    success: function(
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        var response = JSON.parse(text); // Parse response
                                                                                        if (!response.HasError) {
                                                                                            bankname = response; // Store bank name
                                                                                            vthis.clearAll(); // Clear previous options
                                                                                            vthis.parse(bankname.Data); // Parse new bank data
                                                                                        } else {
                                                                                            if (
                                                                                                response.CodeError !=
                                                                                                110012
                                                                                            ) {
                                                                                                webix.message({
                                                                                                    text: response.AlertMessage, // Show alert message
                                                                                                    title: _(
                                                                                                        '¡Mensaje!',
                                                                                                    ),
                                                                                                    type: 'alert-error', // Alert type
                                                                                                });
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                },
                                                                            );
                                                                    }
                                                                },
                                                            },
                                                        },
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: 'button', // Button for transfer action
                                                                value: 'Transferir', // Button label
                                                                click: function(elementId, event) {
                                                                    var values = $$('windowTransfersForm').getValues(); // Get form values
                                                                    var tthis = this; // Reference to current context
                                                                    var amount =
                                                                        '<b>' +
                                                                        values.amount +
                                                                        ' ' +
                                                                        item.Currency +
                                                                        '</b>'; // Format amount for display
                                                                    if (parseFloat(values.amount) >= 10000) {
                                                                        amount =
                                                                            '<b style=\'color: red;font-size: 18px\'>' +
                                                                            values.amount +
                                                                            ' ' +
                                                                            item.Currency +
                                                                            '</b>'; // Highlight amount if above threshold
                                                                    }
                                                                    if ($$('windowTransfersForm').validate()) {
                                                                        var text =
                                                                            _('Advertencia!') +
                                                                            '<br>' +
                                                                            _(
                                                                                'Desea realizar la recarga por valor de: ',
                                                                            ) +
                                                                            '<br>' +
                                                                            amount +
                                                                            '<br>' +
                                                                            _('para el usuario: ') +
                                                                            item.UserName; // Confirmation message
                                                                        if (
                                                                            values.TransactionId &&
                                                                            values.TransactionId !== ''
                                                                        ) {
                                                                            text +=
                                                                                '<br>' +
                                                                                _('Id de transacción relacionada: ') +
                                                                                values.TransactionId; // Append transaction ID if present
                                                                        }
                                                                        if (
                                                                            values.BankId != undefined &&
                                                                            values.BankId !== ''
                                                                        ) {
                                                                            var bank = bankname.Data.findIndex(
                                                                                (element) =>
                                                                                    parseInt(element.id) ==
                                                                                    parseInt(values.BankId), // Find selected bank
                                                                            );
                                                                            text +=
                                                                                '<br>' +
                                                                                _('Banco: ') +
                                                                                bankname.Data[bank].value; // Append bank name
                                                                        }
                                                                        text += '?'; // End confirmation message
                                                                        webix.confirm({
                                                                            type: 'confirm-error', // Confirmation type
                                                                            width: 400, // Confirmation width
                                                                            text: text, // Confirmation text
                                                                            ok: _('Recargar'), // OK button label
                                                                            cancel: _('Salir'), // Cancel button label
                                                                            callback: function(action) {
                                                                                if (action === true) {
                                                                                    webix
                                                                                        .ajax() // AJAX request to perform transfer
                                                                                        .headers({
                                                                                            'Content-type':
                                                                                                'application/json', // Set content type
                                                                                        })
                                                                                        .post(
                                                                                            devConfig.geturlApi() +
                                                                                            'Agent/MakeAgentTransfers', // API endpoint
                                                                                            '{ "Id":' +
                                                                                            item.Id +
                                                                                            ', "Amount":' +
                                                                                            values.amount +
                                                                                            ', "BankId": "' +
                                                                                            values.BankId +
                                                                                            '", "TransactionId": "' +
                                                                                            values.TransactionId +
                                                                                            '", "Type": 1 }', // Request body
                                                                                            {
                                                                                                error: function(
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    webix.message(
                                                                                                        _('Error!'), // Show error message
                                                                                                    );
                                                                                                },
                                                                                                success: function(
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    var data =
                                                                                                        JSON.parse(
                                                                                                            text, // Parse response
                                                                                                        );
                                                                                                    if (data.HasError) {
                                                                                                        if (
                                                                                                            data.CodeError ==
                                                                                                            300060
                                                                                                        ) {
                                                                                                            webix.message(
                                                                                                                {
                                                                                                                    text: 'El número de transferencia ya existe', // Show error for existing transfer number
                                                                                                                    title: _(
                                                                                                                        '¡Error!',
                                                                                                                    ),
                                                                                                                    type: 'alert-error', // Alert type
                                                                                                                },
                                                                                                            );
                                                                                                        } else {
                                                                                                            webix.message(
                                                                                                                {
                                                                                                                    text: data.AlertMessage, // Show alert message
                                                                                                                    title: _(
                                                                                                                        '¡Error!',
                                                                                                                    ),
                                                                                                                    type: 'alert-error', // Alert type
                                                                                                                },
                                                                                                            );
                                                                                                        }
                                                                                                        tthis
                                                                                                            .getTopParentView()
                                                                                                            .hide(); // Hide window on error
                                                                                                    } else {
                                                                                                        webix.message({
                                                                                                            text: 'Se ha realizado la transferencia satisfactoriamente.', // Show success message
                                                                                                            title: _(
                                                                                                                '¡Exito!',
                                                                                                            ),
                                                                                                            type: 'alert-warning', // Alert type
                                                                                                        });
                                                                                                        tthis
                                                                                                            .getTopParentView()
                                                                                                            .hide(); // Hide window on success
                                                                                                    }
                                                                                                },
                                                                                            },
                                                                                        );
                                                                                }
                                                                            },
                                                                        });
                                                                    } else {
                                                                        webix.message({
                                                                            title: _('¡Error!'), // Error title
                                                                            type: 'alert-error', // Alert type
                                                                            text: _('Completa los campos...'), // Error message
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                            {
                                                                view: 'button', // Button for cancel action
                                                                value: _('Cancelar'), // Button label with localization
                                                                click: function(elementId, event) {
                                                                    this.getTopParentView().hide(); // Hide window on cancel
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            move: true, // Allow window movement
                                        })
                                        .show(); // Show the transfer window
                                },
                            },
                            math: true, // Enable math calculations
                            datafetch: 1000, // Data fetch limit
                            pager: 'pagerA', // Pager ID
                            on: {}, // Event handlers
                        },
                        {
                            view: 'treetable', // Second treetable view
                            id: 'treetable2', // ID for the second treetable
                            select: true, // Enable row selection
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'Partner', // Column ID for Partner
                                    header: _('Partner'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    template: function(obj, common) {
                                        if (obj.$level == 1) {
                                            return common.treetable(obj, common); // Return common treetable template for level 1
                                        } else {
                                            return common.treetable(obj, common); // Return common treetable template for other levels
                                        }
                                    },
                                },
                                {
                                    id: 'detailTittle', // Column ID for detail title
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip with localization
                                    template: function(obj) {
                                        if (obj.$level !== 0 && obj.$level !== 1) {
                                            return '<span class=\'webix_icon wxi-close details\'></span>'; // Show details icon for specific levels
                                        } else {
                                            return ''; // Return empty for other levels
                                        }
                                    },
                                },
                                {
                                    id: 'UserId', // Column ID for User ID
                                    header: _('ID Usuario'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column ID for User Name
                                    header: 'UserName', // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Action', // Column ID for Action
                                    header: 'Transf.', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Acción', // Tooltip for action
                                    template: function(obj) {
                                        if (obj.Id != undefined) {
                                            if (devConfig.getPermAction('agentsTreePay', 'Pay')) {
                                                return '<span placeholder=\'Pagar\' class=\'webix_icon wxi-close icon-tranfer prm-agentsTreePay\'></span>'; // Show transfer icon if permission exists
                                            } else {
                                                return ''; // Return empty if no permission
                                            }
                                        } else {
                                            return ''; // Return empty if no ID
                                        }
                                    },
                                },
                                {
                                    id: 'Currency', // Column ID for Currency
                                    header: _('Moneda'), // Column header with localization
                                    width: 70, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AgentBalance', // Column ID for Agent Balance
                                    header: _('Saldo'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Format for displaying price
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    template: function(obj) {
                                        console.log(obj); // Log object for debugging
                                        if (obj.$level !== 0 && obj.$level !== 1) {
                                            return webix.i18n.priceFormat(obj.AgentBalance); // Format balance for display
                                        } else {
                                            return ''; // Return empty for other levels
                                        }
                                    },
                                },
                                {
                                    id: 'SumAgentBalance', // Column ID for Sum Agent Balance
                                    header: _('Consolidado nivel'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Format for displaying price
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    template: function(obj) {
                                        if (obj.$level !== 0) {
                                            return webix.i18n.priceFormat(obj.SumAgentBalance); // Format sum balance for display
                                        } else {
                                            return ''; // Return empty for level 0
                                        }
                                    },
                                },
                            ],
                            scheme: {
                                $change: function(obj, common) {
                                    if (obj.icon == 'icon-user-secret') {
                                        obj.$css = { background: '#f8f8f8' }; // Change background color for specific icon
                                    }
                                },
                            },
                            type: {
                                folder: function(obj, common) {
                                    if (devConfig.getPermAction('filterByCountry', 'Add')) {
                                        if (obj.$level !== 2) {
                                            return '<span class=\'webix_icon ' + obj.icon + '\'></span>'; // Return folder icon for non-level 2
                                        } else {
                                            return '<i class=\'flags ' + obj.flag + '\'></i>'; // Return flag icon for level 2
                                        }
                                    } else {
                                        if (obj.$level !== 1) {
                                            return '<span class=\'webix_icon ' + obj.icon + '\'></span>'; // Return folder icon for non-level 1
                                        } else {
                                            return '<span class=\'partner ' + obj.Partner + '\'></span>'; // Return partner span for level 1
                                        }
                                    }
                                },
                            },
                            onClick: {
                                details: function(euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$('dColl').expand(); // Expand details
                                    this.$scope.app.callEvent('assignmentQuota:id', [item.Id]); // Call event with item ID
                                },
                                'icon-tranfer': function(euv, id) {
                                    var vvthis = this; // Reference to current context
                                    var item = vvthis.getItem(id); // Get the clicked item
                                    webix
                                        .ui({
                                            view: 'window', // Create a window for transfer
                                            head: _('Transferir Saldo a ') + item.UserName, // Window header with localization
                                            id: 'windowTransfers', // ID for the transfer window
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                view: 'form', // Form inside the window
                                                id: 'windowTransfersForm', // ID for the form
                                                elements: [
                                                    {
                                                        view: 'text', // Text input for amount
                                                        label: _('Monto'), // Label with localization
                                                        name: 'amount', // Input name
                                                        id: 'amount', // Input ID
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: 'button', // Button for transfer action
                                                                value: 'Transferir', // Button label
                                                                click: function(elementId, event) {
                                                                    var values = $$('windowTransfersForm').getValues(); // Get form values
                                                                    var tthis = this; // Reference to current context
                                                                    var amount =
                                                                        '<b>' +
                                                                        values.amount +
                                                                        ' ' +
                                                                        item.Currency +
                                                                        '</b>'; // Format amount for display
                                                                    if (parseFloat(values.amount) >= 30000) {
                                                                        amount =
                                                                            '<b style=\'color: red;font-size: 18px\'>' +
                                                                            values.amount +
                                                                            ' ' +
                                                                            item.Currency +
                                                                            '</b>'; // Highlight amount if above threshold
                                                                    }
                                                                    if ($$('windowTransfersForm').validate()) {
                                                                        webix.confirm({
                                                                            type: 'confirm-error', // Confirmation type
                                                                            width: 400, // Confirmation width
                                                                            text:
                                                                                _('Advertencia!') +
                                                                                '<br>' +
                                                                                _(
                                                                                    'Desea realizar la recarga por valor de: ',
                                                                                ) +
                                                                                '<br>' +
                                                                                amount +
                                                                                '<br>' +
                                                                                _('para el usuario: ') +
                                                                                item.UserName +
                                                                                '?', // Confirmation message
                                                                            ok: _('Recargar'), // OK button label
                                                                            cancel: _('Salir'), // Cancel button label
                                                                            callback: function(action) {
                                                                                if (action === true) {
                                                                                    webix
                                                                                        .ajax() // AJAX request to perform transfer
                                                                                        .headers({
                                                                                            'Content-type':
                                                                                                'application/json', // Set content type
                                                                                        })
                                                                                        .post(
                                                                                            devConfig.geturlApi() +
                                                                                            'Agent/MakeAgentTransfers', // API endpoint
                                                                                            '{ "Id":' +
                                                                                            item.Id +
                                                                                            ',"Amount":' +
                                                                                            values.amount +
                                                                                            ',"Type":1}', // Request body
                                                                                            {
                                                                                                error: function(
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    webix.message(
                                                                                                        _('Error! '), // Show error message
                                                                                                    );
                                                                                                },
                                                                                                success: function(
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    var data =
                                                                                                        JSON.parse(
                                                                                                            text, // Parse response
                                                                                                        );
                                                                                                    if (data.HasError) {
                                                                                                        webix.message(
                                                                                                            _(
                                                                                                                'No Se ha realizado la transferencia. Comunicarse con soporte. ',
                                                                                                            ),
                                                                                                        ); // Show error message
                                                                                                        tthis
                                                                                                            .getTopParentView()
                                                                                                            .hide(); // Hide window on error
                                                                                                    } else {
                                                                                                        webix.message(
                                                                                                            _(
                                                                                                                'Se ha realizado la transferencia satisfactoriamente. ',
                                                                                                            ),
                                                                                                        ); // Show success message
                                                                                                        tthis
                                                                                                            .getTopParentView()
                                                                                                            .hide(); // Hide window on success
                                                                                                    }
                                                                                                },
                                                                                            },
                                                                                        );
                                                                                }
                                                                            },
                                                                        });
                                                                    } else {
                                                                        webix.message({
                                                                            title: _('¡Error!'), // Error title
                                                                            type: 'alert-error', // Alert type
                                                                            text: _('Completa los campos...'), // Error message
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                            {
                                                                view: 'button', // Button for cancel action
                                                                value: _('Cancelar'), // Button label with localization
                                                                click: function(elementId, event) {
                                                                    this.getTopParentView().hide(); // Hide window on cancel
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            move: true, // Allow window movement
                                        })
                                        .show(); // Show the transfer window
                                },
                            },
                            math: true, // Enable math calculations
                            datafetch: 1000, // Data fetch limit
                            pager: 'pagerA', // Pager ID
                            on: {}, // Event handlers
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up any necessary event handlers or data loading.
     */
    init() {
        // Construct the API URL for fetching agent downstream agents
        var url = devConfig.geturlApi() + 'Agent/GetAgentDownStreamAgents';
        var grid;

        // Check if the user has permission to filter by country and add
        if (devConfig.getPermAction('filterByCountry', 'Add')) {
            grid = $$('treetable'); // Assign the main grid to the tree table
            $$('treetable2').hide(); // Hide the secondary tree table
            $$('treetable').show(); // Show the main tree table

            // Attach an event handler for when the grid data is loaded
            grid.attachEvent('onAfterLoad', function() {
                // Group the data by country
                grid.data.group({
                    by: 'Country',
                    map: {
                        Currency: ['Currency'],
                        flag: ['flag'],
                        ActionTittle: [''],
                        Country: ['Country'],
                        Partner: ['Partner'],
                        AgentBalance: ['AgentBalance', 'sum'], // Sum of agent balances
                        SumAgentBalance: ['SumAgentBalance', 'sum'], // Sum of agent balances
                    },
                });
                // Group the data by partner
                $$('treetable').data.group({
                    by: 'Partner',
                    map: {
                        ActionTittle: [''],
                        Partner: ['Partner'],
                    },
                });
            });
        } else {
            grid = $$('treetable2'); // Assign the secondary grid to the tree table 2
            $$('treetable').hide(); // Hide the main tree table
            $$('treetable2').show(); // Show the secondary tree table

            // Attach an event handler for when the grid data is loaded
            grid.attachEvent('onAfterLoad', function() {
                // Group the data by partner
                grid.data.group({
                    by: 'Partner',
                    map: {
                        ActionTittle: [''],
                        Partner: ['Partner'],
                        Currency: ['Currency'],
                        AgentBalance: ['AgentBalance', 'sum'], // Sum of agent balances
                        SumAgentBalance: ['SumAgentBalance', 'sum'], // Sum of agent balances
                    },
                });
            });
        }

        // Listen for the 'agentTree:filter' event to apply filters
        this.on(this.app, 'agentTree:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to an array of entries
            var string1 = ''; // Initialize query string for filters

            // Iterate through the filter data entries
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    // Handle object type filters
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Handle start and end date filters
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Append the selected partner to the query string
            string1 = string1 + '&Partner=' + profile.PartnerSelected;
            grid.clearAll(); // Clear the grid before loading new data

            // Load data from the API with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1).then(function(data) {
                data = data.json(); // Parse the JSON response
                if (!data.HasError) {
                    var array = data.Data.Children; // Extract children data from response
                    if (array.length > 0) {
                        // Process each element in the array
                        array.forEach((element) => {
                            if (element.data) {
                                var sumAgentBalance = 0; // Initialize sum for agent balance
                                element.data.forEach((element2) => {
                                    sumAgentBalance = sumAgentBalance + parseFloat(element2.AgentBalance); // Sum agent balances
                                    var sumAgentBalance2 = 0; // Initialize sum for nested agent balance
                                    if (element2.data) {
                                        element2.data.forEach((element3) => {
                                            sumAgentBalance2 = sumAgentBalance2 + parseFloat(element3.AgentBalance); // Sum nested agent balances
                                            var sumAgentBalance3 = 0; // Initialize sum for deeper nested agent balance
                                            if (element3.data) {
                                                element3.data.forEach((element4) => {
                                                    sumAgentBalance3 =
                                                        sumAgentBalance3 + parseFloat(element4.AgentBalance); // Sum deeper nested agent balances
                                                    element4.SumAgentBalance = element4.AgentBalance; // Set sum for the current element
                                                });
                                                sumAgentBalance2 = sumAgentBalance2 + sumAgentBalance3; // Update nested sum
                                                sumAgentBalance = sumAgentBalance + sumAgentBalance3; // Update main sum
                                                element3.SumAgentBalance =
                                                    sumAgentBalance3 + parseFloat(element3.AgentBalance); // Set sum for the nested element
                                            } else {
                                                element3.SumAgentBalance = element3.AgentBalance; // Set sum for the current element
                                            }
                                        });
                                        sumAgentBalance = sumAgentBalance + sumAgentBalance2; // Update main sum
                                        element2.SumAgentBalance = sumAgentBalance2 + parseFloat(element2.AgentBalance); // Set sum for the nested element
                                    } else {
                                        element2.SumAgentBalance = element2.AgentBalance; // Set sum for the current element
                                    }
                                });
                                element.SumAgentBalance = sumAgentBalance + parseFloat(element.AgentBalance); // Set sum for the main element
                            } else {
                                element.SumAgentBalance = element.AgentBalance; // Set sum for the current element
                            }
                        });
                        grid.clearAll(); // Clear the grid before parsing new data
                        grid.parse(array); // Parse the new data into the grid
                    } else {
                        grid.clearAll(); // Clear the grid if no data
                        grid.showOverlay(
                            '<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' + _('No hay datos') + '</div>', // Show overlay if no data
                        );
                    }
                } else {
                    grid.clearAll(); // Clear the grid on error
                    grid.showOverlay(
                        '<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' + _('No hay datos') + '</div>', // Show overlay if no data
                    );
                    webix.message({
                        title: _('¡Error!'), // Show error message
                        type: 'alert-error',
                        text: _('Ocurrio un error, comuniquese con soporte'), // Error description
                    });
                }
            });
            $$('filterPopup').hide(); // Hide the filter popup after applying filters
        });

        // Attach event handler for item click in the grid
        grid.attachEvent('onItemClick', function(id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Attach event handler for before edit start in the grid
        grid.attachEvent('onBeforeEditStart', function(id) {
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                var options = this.getColumnConfig('Action').collection; // Get action column options
                if (item.StateValidate != 'N') {
                    console.log(item);
                    return false; // Prevent editing if state is not valid
                }
                console.log(id);
            }
        });

        // Listen for the 'player:select' event to load data based on selected player
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for the selected player
            );
        });

        // Attach event handler for after sorting in the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            grid.clearAll(); // Clear the grid before loading sorted data
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir, // Load sorted data from the API
            );
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
